export default function About() {
  return (
    <div className="flex flex-col">
      {/* Hero Banner */}
      <div
        className="relative w-full"
        style={{
          background: "linear-gradient(135deg, #1a1a4e 0%, #2d2d6e 35%, #1e2a5e 70%, #152045 100%)",
        }}
      >
        <div className="absolute inset-0 overflow-hidden">
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: "radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.15) 0%, transparent 50%), radial-gradient(ellipse at 70% 30%, rgba(255,255,255,0.1) 0%, transparent 40%)",
            }}
          />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-4 py-20 md:py-28 text-center">
          <h1 className="text-white text-3xl md:text-5xl font-bold uppercase tracking-wider">
            ABOUT US
          </h1>
        </div>
      </div>

      {/* Intro Paragraph */}
      <div className="bg-white">
        <div className="max-w-[1400px] mx-auto px-4 py-10 md:py-14">
          <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-[1100px]">
            ATLAS PRO SERVICES LLC is proudly owned and operated by Husein Mamedov. We are located at 307 S Steele Ave in Picayune, Mississippi, and serve the surrounding Pearl River County area including Poplarville, Nicholson, Carriere, and the greater Gulf Coast region.
          </p>
        </div>
      </div>

      {/* Section 1: Design Your Dream Pool - Text left, Image right */}
      <div className="bg-white">
        <div className="max-w-[1400px] mx-auto px-4 pb-10 md:pb-14">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Design Your Dream Pool
              </h2>
              <p className="text-gray-800 font-semibold text-sm md:text-base mb-3">
                Are you planning on purchasing a pool?
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3">
                Are you still looking for the right idea? Are you thinking of a very special kind of atmosphere?
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Make a free consultation appointment with us today!. We would be glad to hear what you are looking for and to show you some of the solutions we found for other customers. If you do not like what you see, we can always plan and build your dream pool from scratch.
              </p>
            </div>
            <div className="w-full">
              <img
                              src="/images/IMG_1310.jpg"
                alt="ATLAS PRO SERVICES LLC finished pool"
                title="ATLAS PRO SERVICES LLC"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Pool Remodeling - Image left, Text right */}
      <div className="bg-white">
        <div className="max-w-[1400px] mx-auto px-4 pb-10 md:pb-14">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1 w-full">
              <img
                              src="/images/IMG_1304.jpg"
                alt="ATLAS PRO SERVICES LLC"
                title="ATLAS PRO SERVICES LLC"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="order-1 md:order-2">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Pool Remodeling
              </h2>
              <p className="text-gray-800 font-semibold text-sm md:text-base mb-3">
                Do you already have a pool?
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Could it benefit from a few modifications such as a waterfall with night illumination? Or a grotto with cocktail bar? We analyze your pool area and make suggestions for fascinating remodeling or expansion projects.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}